/* global rwgps */
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { OrganizationLayout } from '../OrganizationLayout'
import { _Collections, messages as collectionsMessages } from 'features/homepage/Collections'
import { promiseMapAll } from 'lib/utils'
import { useFormatMessage, privacyLevels } from 'lib/localization'
import {
  COLLECTION_VISIBILITY_PUBLIC,
  COLLECTION_VISIBILITY_MEMBERS,
  COLLECTION_VISIBILITY_MANAGERS
} from 'lib/visibility'
import { Loadable } from 'common/Loadable'
import { collectionActions, collectionSelectors } from 'data/resources/collections'
import { clubActions, clubSelectors } from 'data/resources/clubs'
import { privacyCodeSelectors } from 'data/resources/privacyCodes'
import { OrderedMap } from 'immutable'

const ownershipFilterOpts = fm => OrderedMap({
  all: fm(collectionsMessages.all),
  public: fm(privacyLevels.public),
  members: fm(privacyLevels.mOnly),
  managers: fm(privacyLevels.rmOnly)
})

const filterCollections = (collections, ownership, cuid) => {
  switch (ownership) {
    case 'public':
      return collections.filter(c => c.visibility === COLLECTION_VISIBILITY_PUBLIC)
    case 'members':
      return collections.filter(c => c.visibility === COLLECTION_VISIBILITY_MEMBERS)
    case 'managers':
      return collections.filter(c => c.visibility === COLLECTION_VISIBILITY_MANAGERS)
    default:
      return collections
  }
}

const _OrganizationCollections = ({ collections, currentUser, club, ...props }) => {
  const orgAccountSignedIn = rwgps.config.club?.slug === club.slug

  const fm = useFormatMessage()
  const options = ownershipFilterOpts(fm)
  const [ownership, setOwnership] = useState('all')
  const filteredCollections = filterCollections(collections, ownership, currentUser.id)
  const shareRoot = `/organizations/${club.slug}`

  return (
    <OrganizationLayout>
      <div style={{ width: '1030px', marginLeft: 'auto', marginRight: 'auto' }}>
        <_Collections
          collections={filteredCollections}
          totalCount={collections.size}
          options={options}
          selected={ownership}
          filterLabel={options.get(ownership)}
          onOwnershipChange={ownership => setOwnership(ownership)}
          currentUser={currentUser}
          readOnly={!orgAccountSignedIn}
          user={club}
          shareRoot={shareRoot}
          allowVisibilityUpdate
          renderEmpty={!orgAccountSignedIn}
          {...props}
        />
      </div>
    </OrganizationLayout>
  )
}

const LoadableClubCollections = (props) => {
  const fm = useFormatMessage()
  const { params, location, loadCollections, loadClub } = props
  const clubId = params.clubIdParam

  const loadInitialResources = () => {
    return promiseMapAll({
      _: loadCollections({
        extras: 'privacy_code,user',
        clubId,
        privacyCode: location.query.privacy_code
      }, { identifier: clubId }
      ),
      __: loadClub(params.clubIdParam)
    })
  }

  return <Loadable
    {...props}
    component={_OrganizationCollections}
    loadingText={fm(collectionsMessages.loadableText)}
    resourceLoaded={loadInitialResources} />
}

const mapStateToProps = (state, ownProps) => {
  const collections = collectionSelectors.allForUser(state, ownProps.params.clubIdParam)
  return {
    currentUser: state.currentUser,
    collections,
    club: clubSelectors.bySlug(state, ownProps.params.clubIdParam),
    collectionsPrivacyCode: privacyCodeSelectors.byParentWithScope(state, 'User', state.currentUser.id, 'collections')
  }
}

const mapDispatchToProps = {
  loadCollections: collectionActions.list,
  loadClub: clubActions.read
}

export const OrganizationCollections = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableClubCollections)
